import i18n from '@/app/i18n.ts'

import en from '@/modules/game/shared/lib/i18n/en_US.json'
import ja from '@/modules/game/shared/lib/i18n/ja_jp.json'

if (!i18n.getResourceBundle('en', 'default')) {
  i18n.addResourceBundle('en', 'default', en)
}

if (!i18n.getResourceBundle('ja', 'default')) {
  i18n.addResourceBundle('ja', 'default', ja)
}
